import React from 'react';
import {
  AgencyEnquiryFormWithFragment,
  InView,
  SectionWrapper,
} from '../../components';
import { COMPONENT_IDS } from '../../constants';
import AgencyRecommendations from '../../components/agency-recommendations/agency-recommendation';
import { ReviewsProvider } from '../../components/recommendations-enquiry-section';

type AgencyRecommendationsWithoutStarRatingsProps = {
  agencyId: number;
  starRatingsEnabled: boolean;
  onActivate: (inView: boolean) => void;
  onSubmit: () => void;
};

export const AgencyRecommendationsWithoutStarRatings: React.FC<
  AgencyRecommendationsWithoutStarRatingsProps
> = ({ agencyId, starRatingsEnabled, onActivate, onSubmit }) => (
  <>
    <SectionWrapper componentId={COMPONENT_IDS.recommendations}>
      <ReviewsProvider>
        <AgencyRecommendations
          agencyId={agencyId}
          starRatingsEnabled={starRatingsEnabled}
        />
      </ReviewsProvider>
    </SectionWrapper>
    <SectionWrapper
      componentId={COMPONENT_IDS.enquiryForm}
      bottomBorder={false}
    >
      <InView onActivate={onActivate}>
        <AgencyEnquiryFormWithFragment
          agencyId={agencyId}
          onSubmit={onSubmit}
        />
      </InView>
    </SectionWrapper>
  </>
);

export default AgencyRecommendationsWithoutStarRatings;
